import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PocListRoutingModule } from './poc-list-routing.module';
import { PocListComponent } from './poc-list.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';


@NgModule({
  declarations: [
    PocListComponent
  ],
    imports: [
        CommonModule,
        PocListRoutingModule,
        NgxPaginationModule,
        FormsModule,
        NgSelectModule,
        NgbDropdownModule
    ]
})
export class PocListModule { }
